import { AlertDefaults, Facility } from 'src/app/hickory-api';
import { AlertModelService } from '../alert-model.service';
import { AlertFields } from './alert-fields-helper';

export class AlertFacilitiesHelper {
  // ROAD-11381 - limit to single facility
  static get isSelectionModeSingle(): boolean {
    return true;
  }
  static postProcess(service: AlertModelService, alert: AlertDefaults = service.alertSettings) {
    this.maybeRestrictSelectionsToSingle(alert);
  }

  static preparePreview(_service: AlertModelService, preview: AlertDefaults) {
    this.maybeRestrictSelectionsToSingle(preview);
  }

  static maybeRestrictSelectionsToSingle(alert: AlertDefaults) {
    if (!this.isSelectionModeSingle) return;
    if (!alert.location?.facilities?.length) return;
    // ROAD-11381 - limit to single facility
    alert.location.facilities = alert.location.facilities.slice(0, 1);
  }

  static selectedFacilities(service: AlertModelService): Facility[] {
    return [...(service.alertFacilities ?? []), ...(service.mapFacilities ?? []).flatMap((m) => m.facilities)];
  }

  static summaryText(service: AlertModelService): string {
    const text: string[] = [];

    if (service.alertFacilities?.length) {
      text.push(
        service.alertFacilities.length === 1
          ? service.alertFacilities[0].name
          : service.alertFacilities.length + ' Facilities',
      );
    }

    const areasReferences = service.alertFacility?.areas;
    if (areasReferences?.length) {
      const areas = service.alertLocation?.areas;
      const validAreas = areas.filter((a) => areasReferences?.find((ar) => ar?.id === a.id));
      if (validAreas?.length) {
        text.push(validAreas.length + ' ' + (validAreas.length > 1 ? 'Areas' : 'Area'));
      }
    }

    return text.join(', ');
  }

  static isValidForIncidents(service: AlertModelService): boolean {
    const hasIncidentEvent = !!service.alertIncidentEvent;
    const totalFacilityCount = service.allFacilityIds.length;

    return !hasIncidentEvent || (hasIncidentEvent && totalFacilityCount <= 1);
  }

  static validate(service: AlertModelService): string[] {
    const errors = [];
    const mapFacilityCount = service.state?.mapFacilities?.length ?? 0;
    const facilityCount = service.alertFacilities?.length ?? 0;

    if (!facilityCount && !mapFacilityCount && service.fieldIsRequired(AlertFields.FACILITIES)) errors.push('Alert.Facilities.Required');

    if (!this.isValidForIncidents(service)) {
      errors.push('Alert.Facilities.IncidentValidation');
    }

    return errors;
  }
}
